import React from "react"
import Modal from "@kit/design/modal"
import Button from "@kit/design/button"
import Icon from "@kit/design/icon"
import { useVerticalNavOptIn } from "./utils/use-vertical-nav-optin"
import OldNavIllustration from "./assets/oldnav.svg"
import NewNavIllustration from "./assets/newnav.svg"

// TODO(BUIL-5427): point at the help center article once it's published.
const LEARN_MORE_URL = "https://help.kit.com/"

export function VerticalNavOptInModal() {
  const { shouldShowModal, chooseOldNav, enableVerticalNav } =
    useVerticalNavOptIn()

  if (!shouldShowModal) return null

  return (
    <Modal
      ariaLabel="Meet Kit's new navigation"
      width={720}
      hideHeader
      hideCloseButton
      fullBleed
      onDismiss={undefined}
      onClose={() => {}}
      className="rounded-xl overflow-hidden"
    >
      <div className="flex flex-col items-center gap-8 p-8">
        <div className="flex w-full flex-col items-center gap-4">
          <p className="text-xs font-semibold uppercase leading-4 text-gray-700">
            UI update
          </p>
          <h1 className="text-center font-heading text-5xl leading-none text-gray-900">
            Meet Kit&rsquo;s new navigation
          </h1>
          <p className="text-center text-base leading-6 text-gray-900">
            Explore a better way to navigate Kit. Creators in testing found what
            they needed 40% faster. You can switch back to the old navigation in
            your account menu.{" "}
            <a
              href={LEARN_MORE_URL}
              target="_blank"
              rel="noreferrer"
              className="font-semibold text-blue-700"
            >
              Learn more
            </a>
          </p>
        </div>
        <div className="flex w-full items-center justify-center gap-4">
          <div className="flex flex-1 flex-col items-start">
            <div className="flex w-full items-center justify-center p-2">
              <p className="text-xs font-semibold leading-5 text-gray-900">
                BEFORE
              </p>
            </div>
            <OldNavIllustration className="h-auto w-full" />
            <div className="w-full pt-6">
              <Button
                is="outlined"
                size="lg"
                className="w-full justify-center"
                onClick={chooseOldNav}
              >
                Continue with old navigation
              </Button>
            </div>
          </div>
          <Icon name="long-arrow-right" className="shrink-0 text-gray-900" />
          <div className="flex flex-1 flex-col items-start">
            <div className="flex w-full items-center justify-center p-2">
              <p className="text-xs font-semibold leading-5 text-gray-900">
                AFTER
              </p>
            </div>
            <NewNavIllustration className="h-auto w-full" />
            <div className="w-full pt-6">
              <Button
                is="primary"
                size="lg"
                className="w-full justify-center"
                onClick={enableVerticalNav}
              >
                Explore the new navigation
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
